import { ArrowUpRight, Check, Phone } from 'lucide-react'
import { SectionHeading } from '../components/SectionHeading'
import { ServiceCard } from '../components/ServiceCard'
import { serviceAreas, services, site } from '../content/site'

export function ServicesPage() {
  return (
    <>
      <section className="page-hero page-hero--services">
        <div className="shell page-hero__grid">
          <div>
            <p className="eyebrow eyebrow--light">Aquarium services</p>
            <h1>Design it for the room. Engineer it for real life.</h1>
          </div>
          <div>
            <p>One experienced team for custom aquariums, routine service, urgent repair, and livestock guidance across Southern California.</p>
            <a className="button button--accent" href="/contact/">Discuss your system <ArrowUpRight aria-hidden="true" /></a>
          </div>
        </div>
      </section>

      <section className="section service-detail-section">
        <div className="shell service-detail-list">
          {services.map((service) => <ServiceCard key={service.id} service={service} detailed />)}
        </div>
      </section>

      <section className="section section--sand">
        <div className="shell service-fit-grid">
          <SectionHeading
            eyebrow="A practical first conversation"
            title="We can usually narrow the next step quickly."
            body="A few photos and a clear description are often enough to identify what needs an on-site visit, what can be planned remotely, and what needs immediate attention."
          />
          <div className="service-fit-list">
            {[
              'Planning a new residential or commercial aquarium',
              'Taking over a system that is difficult to maintain',
              'Solving chronic filtration, plumbing, or water-quality issues',
              'Caring for a reef, planted tank, pond, or aquaponic system',
              'Responding to a leak, equipment failure, or livestock emergency',
            ].map((item) => <p key={item}><Check aria-hidden="true" />{item}</p>)}
          </div>
        </div>
      </section>

      <section className="section service-area-section">
        <div className="shell service-area-grid">
          <div>
            <p className="eyebrow">Service area</p>
            <h2>Southern California, Santa Barbara to San Diego.</h2>
            <p>Regular coverage includes Ventura County, Los Angeles County, and surrounding communities. Ask about scheduling outside the core area.</p>
            <a className="text-link" href={site.phoneHref}><Phone aria-hidden="true" /> {site.phoneDisplay}</a>
          </div>
          <div className="area-cloud" aria-label="Cities served">
            {serviceAreas.map((area) => <span key={area}>{area}</span>)}
          </div>
        </div>
      </section>
    </>
  )
}
